<div class="container-tabs">
  <ul class="tabs">
    <li class="tab">
      <a class="tab-link active" routerLinkActive="active">my profile</a>
    </li>
  </ul>
</div>
<div class="user-container">
  <div class="user-image-container">
    @if (userPhotoUrl$ | async; as userPhotoUrl) {
    <img [src]="userPhotoUrl" class="user-photo" />
    } @else {
    <mat-icon class="user-photo-placeholder">person</mat-icon>
    }
  </div>
  @if (userInfo$ | async; as currentUserProfile) {
  <div class="user-info">
    {{ currentUserProfile.displayName }}
  </div>
  <div class="job-title">{{ currentUserProfile.jobTitle }}</div>
  }
</div>
@if (myProjects$ | async; as myProjects) {
<div class="assignments">
  <div class="assignment-section">
    <div class="assignment-number">
      {{ myProjects.length }}
    </div>
    <div class="assignment-description">Projects assigned</div>
  </div>
</div>
}
